import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JaldeeReportService } from 'src/app/services/jaldee-report.service';
@Component({
  selector: 'app-cancel-report',
  templateUrl: './cancel-report.component.html',
  styleUrls: ['./cancel-report.component.css']
})
export class CancelReportComponent implements OnInit {
  public reimburseForm: UntypedFormGroup;
  api_error;
  api_success;
  invoiceDetails: any;
  reimbursePaidDetails: Object;
  showPaymentRadio = false;
  btndisabled = false;
  showReimbursePay = false;
  disableConfirmbtn = false;
  constructor(private formbuilder: UntypedFormBuilder, private matDialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any, private reportService: JaldeeReportService) { }
  ngOnInit() {
    this.invoiceDetails = this.data;
    console.log(this.invoiceDetails)
}
onConfirm() {

  this.reportService.cancelReport(this.data.id)
    .subscribe(res => {
      this.api_success = 'Report Cancelled Successfully';
      setTimeout(() => {
        this.matDialogRef.close();
      }, 2000);

    },
      (error) => {
        this.api_error = error.error;
      });
}
}